import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";
import AssetMiddleware from "../../../../middleware/modules/accounting/asset";
import Asset from "../../../../components/modules/accounting/asset";
// middlewares

const mapStateToProps = ({ auth, asset }) => ({
  isProcessing: asset.isProcessing,
  isError: asset.isError,
  errorMessage: asset.errorMessage,
  datalist: asset.data,
  helperAsset: asset.helperAsset,
  afterSave: asset.afterSave,
  showModal: asset.showModal
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      create: () => AssetMiddleware.create(),
      getHelper: () => AssetMiddleware.getHelper(),
      reset: () => AssetMiddleware.resetList(),
      search: (data) => AssetMiddleware.list(data),
      update: (data) => AssetMiddleware.update(data),
      view: (data) => AssetMiddleware.update(data),
      void: (data,search) => AssetMiddleware.beforeVoid(data,search),
      delete: (id, search) => AssetMiddleware.beforeDelete(id, search),
      submit: (data, search) => AssetMiddleware.beforeSaveNew(data, search),
    },
    dispatch
  );
};
class AssetContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired,
    afterSave: PropTypes.bool,

  };

  static defaultProps = {
    afterSave: false,
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  constructor(props) {
    super(props);
    this.submitItem = this.submitItem.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.createItem = this.createItem.bind(this);
    this.viewItem = this.viewItem.bind(this);
    this.voidItem = this.voidItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
    this.props.search(search);
  }

  createItem() {
    this.props.getHelper();
    this.props.create();
  }

  updateItem(id) {
    this.props.getHelper();
    this.props.update(id);
  }

  viewItem(id) {
    this.props.view(id);
  }

  submitItem() {
    this.props.submit();
  }

  voidItem(data,search) {
    this.props.void(data,search);
  }

  render() {
    const { isProcessing, search, datalist, showModal } =
      this.props

    return (
      <React.Fragment>
        <Helmet>
          <title>{i18n.t("Asset Type List")}</title>
        </Helmet>
        <Asset
          {...this.props}
          createData={this.createItem}
          updateItem={this.updateItem}
          viewItem={this.viewItem}
          voidItem={this.voidItem}
          showModal={showModal}
        />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AssetContainer);
